<template>
  <v-container fluid class="hero">
    <v-row align="center" justify="center">
      <v-col sm="12" lg="5" md="12">
        <v-card class="elevation-15 pt-4 light_opacity">
          <v-window v-model="step">
            <v-window-item :value="0">
              <v-row>
                <v-col cols="12">
                  <v-card-title class="py-10">
                    <div class="text-center row justify-center">
                      <h1
                        class="font-weight-light"
                        style="color: #3c4858; font-size: 36px"
                      >
                        <img
                          width="80%"
                          src="@/assets/img/rebase_logo_white.png"
                        />
                      </h1>
                    </div>
                  </v-card-title>
                  <v-card-text class="my-5">
                    <v-form
                      ref="registerFrm"
                      @submit.prevent="registerUser"
                      lazy-validation
                    >
                      <v-row>
                        <h3 class="ml-4">
                          Please give us your personal and contact details
                        </h3>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="6">
                              <v-text-field
                                v-model="register.firstName"
                                label="First Name"
                                name="name"
                                clearable
                                :rules="firstNameRules"
                                append-icon="mdi-account-arrow-left"
                                required
                                outlined
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                v-model="register.lastName"
                                label="Last Name"
                                name="last_name"
                                clearable
                                :rules="lastNameRules"
                                append-icon="mdi-account-arrow-left"
                                required
                                outlined
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field
                            v-model="register.email"
                            label="Email"
                            name="email"
                            type="email"
                            :rules="emailRules"
                            append-icon="mdi-email"
                            required
                            outlined
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="register.telNumber"
                            label="Mobile"
                            name="tel_number"
                            clearable
                            append-icon="mdi-phone"
                            :rules="telNumberRules"
                            required
                            outlined
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="register.altNumber"
                            label="Alt Mobile"
                            clearable
                            name="tel_number"
                            append-icon="mdi-phone"
                            :rules="telNumberRules"
                            required
                            outlined
                          />
                        </v-col>
                        <v-col cols="6">
                          <h3>
                            Have you used rebase before?<br /><span
                              ><h6>
                                (Switch Right=Yes, Switch left = No)
                              </h6></span
                            >
                          </h3>
                          <v-switch
                            class="mb-5 ml-2"
                            v-model="interestQuestion"
                            label="Yes"
                            outlined
                          />
                        </v-col>
                        <v-col cols="6" v-if="!interestQuestion">
                          <h3>
                            Which insurance category are you interested in?
                          </h3>
                          <base-product-category-picker
                            :chosen-product-category.sync="
                              register.productsInterestedIn
                            "
                            label="Insurance Category"
                            multiple
                            outlined
                          />
                        </v-col>
                        <v-col cols="6" v-if="interestQuestion">
                          <h4>
                            Great, which products have you used with them?
                          </h4>
                          <base-product-picker
                            :chosen-product.sync="register.existingProducts"
                            label="Products"
                            multiple
                            outlined
                          />
                        </v-col>
                      </v-row>
                      <!-- <v-row>
                        <v-col cols="12" md="1" sm="12">
                          <v-date-picker v-model="register.dob" />
                        </v-col>
                      </v-row> -->
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            v-model="register.password"
                            :append-icon="
                              toggled == true ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            :append-icon-cb="switchToggle"
                            label="Password"
                            name="password"
                            :rules="passwordRules"
                            clearable
                            required
                            outlined
                            :type="toggled == true ? 'text' : 'password'"
                            @click:append="switchToggle"
                          />
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="register.confirm"
                            :append-icon="
                              toggled == true ? 'mdi-eye' : 'mdi-eye-off'
                            "
                            :append-icon-cb="switchToggle"
                            label="Confirm"
                            name="confirm"
                            :type="toggled == true ? 'text' : 'password'"
                            @click:append="switchToggle"
                            clearable
                            :rules="[
                              !!register.confirm ||
                                'Password Confirmation required',
                              (register.confirm &&
                                register.confirm == register.password) ||
                                'Passwords do not match',
                            ]"
                            required
                            outlined
                          />
                        </v-col>
                        <v-row class="mx-4">
                          <base-referral-picker
                            :chosen-referral.sync="register.referral"
                            label="Who referred you to us"
                            multiple
                            outlined
                          />
                        </v-row>
                      </v-row>
                      <vue-recaptcha
                        ref="recaptcha"
                        @verify="onVerify"
                        @expired="onExpired"
                        sitekey="6LfCX1EhAAAAAEyP7820FvlNTZdbb-gXGuWAWm_w"
                        class="recaptchax"
                        @click="executeRecaptcha"
                        :loadRecaptchaScript="true"
                      >
                      </vue-recaptcha>
                      <div class="text-center mt-4">
                        <v-btn
                          color="primary"
                          large
                          block
                          class="mx-2"
                          type="submit"
                          :disabled="valid"
                          @click="registerUser()"
                          >CREATE ACCOUNT</v-btn
                        >
                        <!-- @click="[registerUser(), routeTorebaseWebsite()]" -->
                      </div>
                    </v-form>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-window-item>
          </v-window>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { gql } from "apollo-boost";
import { User } from "@/models/User";
import VueRecaptcha from "vue-recaptcha";
export default {
  name: "Register",
  components: {
    VueRecaptcha,
  },
  data: () => ({
    interestQuestion: false,
    toggled: false,
    ping: "",
    step: 0,
    register: new User(),
    firstNameRules: [(v) => !!v || "First name is required"],
    lastNameRules: [(v) => !!v || "Last name is required"],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    telNumberRules: [(v) => !!v || "Mobile Number is required"],
    passwordRules: [
      (v) => !!v || "Password is required",
      (v) => (v && v.length >= 6) || "minimum 6 characters",
    ],
    successMsg: "",
    errorMsg: "",
    valid: true,
  }),
  apollo: {
    ping: {
      query: gql`
        query {
          ping
        }
      `,
      fetchPolicy: "network-only",
      result(data, key) {},
    },
  },
  created() {
    this.$swal({
      title: "rebase Disclaimer",
      // "<img src='/src/assets/AspireHowtoGif.gif' width='500' height'600'>
      html: "rebase is committed to maintaining the confidentiality of your personal information and complying with the Protection of Personal Information Act 2013, when processing your personal information. The personal information we require relates not only to you but also to your child and adult dependents, and you confirm that you are authorised to provide consent in this section on behalf of your dependents. You authorise, and give consent to, rebase to collect, store, collate, process, share and further process your personal information and that of your dependents, for purposes of your membership with rebase.You understand that your personal information will be shared between rebase and contracted third parties (Product Providers) who require this information, for purposes related to your membership.<br><br><br>If at any point you need help, call <a href='tel:0860350950'>086 035 0950</a>  ",
    });
  },
  methods: {
    async routeTorebaseWebsite() {
      window.location.href = "https://www.rebase.co.za/contacts/";
    },
    switchToggle() {
      this.toggled = !this.toggled;
    },
    executeRecaptcha() {
      this.$refs.recaptcha.execute();
    },
    onVerify: function (response) {
      console.log("Verify: " + response);
      return (this.valid = !this.valid);
    },
    onExpired: function () {
      console.log("Expired");
      return (this.valid = !this.valid);
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
    async loginUser() {
      const self = this;
      if (!self.$refs.signinFrm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        return;
      }
      try {
        const userData = await this.$apollo.mutate({
          mutation: gql`
            mutation ($email: String!, $password: String!) {
              login(email: $email, password: $password) {
                user {
                  id
                  email
                  role
                }
                token
              }
            }
          `,
          variables: {
            email: this.signin.email,
            password: this.signin.password,
          },
        });

        if (userData) {
          this.$token = userData?.data?.login?.token;
          this.$role = userData?.data?.login?.user?.role;
          localStorage.setItem("token", this.$token);
          localStorage.setItem("role", userData?.data?.login?.user?.role);

          if (this.$role == "user") this.$router.push("/user/dashboard");
          if (this.$role == "admin") this.$router.push("/admin/dashboard");
          if (this.$role == "consultant")
            this.$router.push("/consultant/contacts");
        }
      } catch (e) {
        console.log(`Login Failed ${JSON.stringify(e)}`);
        self.$swal("Error", e.graphQLErrors[0].message, "error");
        self.errorMsg = `${e.message}`;
      }
    },

    async registerUser() {
      const self = this;
      if (!self.$refs.registerFrm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        return;
      }
      try {
        const userData = await this.$apollo.mutate({
          mutation: gql`
            mutation createUser($user: UserCreateInput!) {
              createUser(user: $user) {
                id
              }
            }
          `,
          variables: {
            user: {
              firstName: this.register.firstName,
              lastName: this.register.lastName,
              email: this.register.email,
              telNumber: this.register.telNumber,
              altNumber: this.register.altNumber,
              password: this.register.password,
              fullAddress: this.register.fullAddress,
              existingProducts: this.register.existingProducts,
              productsInterestedIn: this.register.productsInterestedIn,
              referral: this.register.referral,
              role: "lead",
              source: "Registered on Website",
            },
          },
        });

        if (userData) {
          self.$token = userData.data.createUser.token;
          localStorage.setItem("token", self.$token);
          localStorage.setItem("role", "lead");
          this.step--;
          this.$swal(
            "Success",
            "You have successfully registered, please login",
            "success"
          );
        }
      } catch (e) {
        // TODO SWAL error
        this.$swal(
          "Error",
          `Unfortuantely we were unable to register you because: ${e.message}`,
          "error"
        );
        console.log(`Registration Failed ${JSON.stringify(e)}`);
        self.errorMsg = `${e.message}`;
      }
    },
    async forgotPassword() {
      const self = this;
      try {
        await this.$apollo
          .mutate({
            mutation: gql`
              mutation getResetPasswordLink($email: String!) {
                getResetPasswordLink(email: $email)
              }
            `,
            variables: {
              email: self.forgot.email,
            },
          })
          .then(() => {
            self.$swal(
              "Success",
              "Please check your email for reset password link.",
              "success"
            );
          });
      } catch (e) {
        console.log(`Forgot Password fetch link failed: ${JSON.stringify(e)}`);
        self.errorMsg = `${e.message}`;
      }
    },
  },
};
</script>

<style scoped>
.hero {
  background: url("../../assets/img/loginBackground.jpeg");
  background-size: cover;
  height: 100%;
}
</style>
